interface Adaptation {
  chat_id: string;
  filter: 'all_companies' | 'current_company';
}

export function livechatTemplatesFilterCompanyAdapter(
  attendanceId: string,
  companyFilter: 'all_companies' | 'current_company'
): Adaptation {
  return {
    chat_id: attendanceId,
    filter: companyFilter || 'all_companies',
  }
}
